define.alias("shared/utils/plans-data/index", "settings/utils/plans-data");